export default "__VITE_ASSET__a1Q64D1f__"